export var ServiceType;
(function (ServiceType) {
    ServiceType["GiftWrapping"] = "GIFT_WRAPPING";
    ServiceType["Engraving"] = "ENGRAVING";
})(ServiceType || (ServiceType = {}));
